import { Binder } from '@ribajs/core'
import type { ShopifyMediaImage } from '../types/index'

/**
 * Set the aspect ratio of an element based on the aspect ratio of the media object
 *
 * @example
 * <img rv-shopify-media-aspect-ratio="image.media" />
 */
export class ShopifyMediaAspectRatioBinder extends Binder<
  ShopifyMediaImage,
  HTMLElement
> {
  static key = 'shopify-media-aspect-ratio'

  routine(el: HTMLElement, media?: ShopifyMediaImage) {
    if (media && media.width && media.height) {
      const aspectRatio = media.aspect_ratio || media.width / media.height
      el.style.aspectRatio = `${aspectRatio}`
      return
    }

    if (el instanceof HTMLImageElement) {
      const width = el.width
      const height = el.height
      const aspectRatio = width / height
      el.style.aspectRatio = `${aspectRatio}`
      return
    }

    console.warn('shopify-media-aspect-ratio: No media found', el)
  }
}
